import React, { useState, useEffect } from "react";
import Invest from "../../Assets/images/in.png";
import Skeleton from "@mui/material/Skeleton";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import TrendingDownRoundedIcon from "@mui/icons-material/TrendingDownRounded";
import getServices from "../../Services/get-service";
import { toast } from "react-toastify";

function InvestmentBalanceCards() {
  const [data, setData] = useState({
    portfolioValue: 0,
    totalInvested: 0,
    annualReturns: 0,
    annualReturnsTrend: "",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTiles = async () => {
      setLoading(true);
      try {
        const response = await getServices.getPropertyInvestmentBalance();
        // console.log("Investment tiles response:", response?.data);
        if (response?.data?.statusCode === 200) {
          setData(response.data.data);
        }
      } catch (error) {
        toast.error(error, {
          autoClose: 1000,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchTiles();
  }, []);

  const formatAmount = (value) => {
    return Number(value ?? 0).toLocaleString("en-NG", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <div className="grid md:grid-cols-3 gap-4 my-4 cursor-pointer">
      {/* Portfolio Value Card */}
      <div className="border rounded-xl px-5 py-3 border-[#E6E6E7] bg-[#ffffff] flex justify-between items-center shadow-sm">
        <div>
          <p className="text-[#6B7281] text-[14px] font-[400] mb-1 uppercase tracking-wider">
            Portfolio Value
          </p>
          <p className="text-[32px] font-[700] text-[#1E222B] mb-1">
            {loading ? (
              <Skeleton variant="text" width={140} height={40} />
            ) : (
              <>₦ {formatAmount(data.portfolioValue)}</>
            )}
          </p>
          {/* <p className="text-primary-color text-[12px] font-[400]">
            +8.3% total return
          </p> */}
        </div>
        <div className="w-12 h-12 rounded-full bg-[#E6F8F0] flex items-center justify-center">
          <img src={Invest} alt="Invest" className="w-6 h-6 object-contain" />
        </div>
      </div>

      {/* Total Invested Card */}
      <div className="border rounded-xl px-5 py-3 border-[#E6E6E7] bg-[#ffffff] flex justify-between items-center shadow-sm">
        <div>
          <p className="text-[#6B7281] text-[14px] font-[400] mb-1 uppercase tracking-wider">
            Total Invested
          </p>
          <p className="text-[32px] font-[700] text-[#1E222B] mb-1">
            {loading ? (
              <Skeleton variant="text" width={140} height={40} />
            ) : (
              <>₦ {formatAmount(data.totalInvested)}</>
            )}
          </p>
          {/* <p className="text-[#000000] text-[12px] font-[400]">
            3 active positions
          </p> */}
        </div>
        <div className="w-12 h-12 rounded-full bg-[#E6F8F0] flex items-center justify-center">
          <img src={Invest} alt="Invest" className="w-6 h-6 object-contain" />
        </div>
      </div>

      {/* Annual Dividends Card */}
      <div className="border rounded-xl px-5 py-3 border-[#E6E6E7] bg-[#ffffff] flex justify-between items-center shadow-sm">
        <div>
          <p className="text-[#6B7281] text-[14px] font-[400] mb-1 uppercase tracking-wider">
            Annual Dividends
          </p>

          <div className="flex items-center gap-2 mb-1">
            {loading ? (
              <Skeleton variant="text" width={160} height={40} />
            ) : (
              <>
                <p className="text-[32px] font-[700] text-[#1E222B]">
                  ₦ {formatAmount(data.annualReturns)}
                </p>

                {data.annualReturnsTrend === "UP" ? (
                  <TrendingUpRoundedIcon
                    sx={{
                      fontSize: 22,
                      color: "#00BC67",
                    }}
                  />
                ) : data.annualReturnsTrend === "DOWN" ? (
                  <TrendingDownRoundedIcon
                    sx={{
                      fontSize: 22,
                      color: "#DC2626",
                    }}
                  />
                ) : null}
              </>
            )}
          </div>
        </div>

        <div className="w-12 h-12 rounded-full bg-[#E6F8F0] flex items-center justify-center">
          <img src={Invest} alt="Invest" className="w-6 h-6 object-contain" />
        </div>
      </div>
    </div>
  );
}

export default InvestmentBalanceCards;
